export default {
  addOns: 'Zusätze',
  availabilityDaySelector: 'Verfügbarkeitsdatum-Auswahl',
  unavailable: 'Nicht verfügbar',
  person: 'Person',
  people: 'Personen',
  reserveNow: 'Jetzt reservieren',
  selectTime: 'Zeit auswählen',
  select: 'Auswählen',
  reserve: 'Reservieren',
  time: 'Zeit',
  tier: 'Stufe',
  questions: 'Fragen',
  addToCart: 'In den Warenkorb',
  checkout: 'Kasse',
  total: 'Gesamt',
  availability: 'Verfügbarkeit',
  whatsIncluded: 'Was ist enthalten',
  showMore: 'Mehr anzeigen',
  showLess: 'Weniger anzeigen',
  session: 'Sitzung',
  viewDetails: 'Details anzeigen',
  findAvailability: 'Verfügbarkeit finden',
  loading: 'Laden',
  capacity: 'Kapazität',
  noAvailableSessionsOnThisDate: 'Keine verfügbaren Sitzungen an diesem Datum',
  noGroupAvailableOnThisDateAndTime:
    'Keine {{groupTitle}} verfügbar an diesem Datum und zu dieser Zeit',
  noCollectionFound: 'Keine Sammlung gefunden!',
  noResourceGroupFound: 'Keine Ressourcengruppe gefunden!',
  noData: 'Keine Daten!',
  continue: 'Weiter',
  night: 'Nacht',
  nights: 'Nächte',
  noAvailableSessionsForSelectedDates:
    'Einige Daten in Ihrer Auswahl haben keine verfügbaren Sitzungen. Bitte wählen Sie andere Daten aus.',
  from: 'ab',
  dateRangeSelector: 'Datumsbereichsauswahl',
  priceTierRadioGroup: 'Radio-Button-Gruppe für Preisstufen',
  startTime: 'Startzeit',
  duration: 'Dauer',
  lengthOfStay: 'Aufenthaltsdauer',
  startDate: 'Startdatum',
  endDate: 'Enddatum',
  selectDates: 'Daten auswählen',
  more: 'Mehr',
  selectStartTime: 'Startzeit wählen',
  endTime: 'Endzeit',
  selectEndTime: 'Endzeit wählen',
  morning: 'Vormittag',
  afternoon: 'Nachmittag',
  save: 'Speichern',
  selectDuration: 'Dauer wählen',
  forLength: 'für {{length}}',
  moreDates: '{{count}} weitere',
  addDate: 'Datum hinzufügen',
  start: 'Beginn',
  end: 'Ende',
  pickupFrom: 'Abholung ab',
  returnBy: 'Rückgabe bis',
  day: 'Tag',
  days: 'Tage',
  hour: 'Stunde',
  hours: 'Stunden',
};
